import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-shapefile-data-dialog',
    templateUrl: './shapefile-data-dialog.component.html',
    styleUrls: ['./shapefile-data-dialog.component.scss']
})
export class ShapefileDataDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<ShapefileDataDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { features: any[], shapefileProperties: string[] }
    ) {
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
